import { register } from "@rill/loader";

register(
  {
    name: "comments",
    meta: ["no-bust", "comment"],
    ttl: "2 hours",
  },
  async ({ api }, { threadId }) => {
    if (!threadId) return;
    const res = await api("comment", {
      query: { threadId, sort: { createdAt: 1 } },
    });
    return await res.json();
  }
);

/**
 * Load comments for multiple meal-photo threads in one go (single API request).
 * @param {Array<{ photoId: string, threadId: string }>} photoThreadMap - from daily stat mealPhotos lists
 * @returns {Promise<Record<string, Array>>} { [photoId]: comment[] }
 */
register(
  {
    name: "mealComments",
    meta: ["no-bust", "comment"],
    ttl: "2 hours",
  },
  async ({ api }, { photoThreadMap }) => {
    if (!Array.isArray(photoThreadMap) || photoThreadMap.length === 0) {
      return {};
    }
    const threadIds = photoThreadMap
      .map(({ threadId }) => threadId)
      .filter(Boolean);
    if (threadIds.length === 0) {
      return photoThreadMap.reduce((acc, { photoId }) => {
        acc[photoId] = [];
        return acc;
      }, {});
    }
    const res = await api("comment-by-threads", {
      query: { threadIds: threadIds.join(",") },
    });

    const { mealCommentsByThreadId } = await res.json();

    return photoThreadMap.reduce((acc, { photoId, threadId }) => {
      const key = threadId ? String(threadId) : null;
      acc[photoId] =
        key && mealCommentsByThreadId[key] ? mealCommentsByThreadId[key] : [];
      return acc;
    }, {});
  }
);
